type ColourTheme = {
  [key: string]: string;
};

export const colourThemes: ColourTheme = {
  cyan: "#09CCC4",
  cyan2: "#23B59A",
  purple1: "#5447EF",
  purple2: "#9348DF",
  pink: "#C96EE9",
  red: "#EB5757",
  orange: "#F2994A",
  yellow: "#F2C94C",
  blue1: "#2F80ED",
  blue2: "#2D9CDB",
  blue3: "#56CCF2",
  green1: "#23A359",
  green2: "#5BD158",
  grey1: "#565D76",
  grey2: "#95907A",
};

export const COLOUR_PALETTES = {
  // http://paletton.com/#uid=14F0u0kusraEqeJvTlbpxvkkoBr

  // http://paletton.com/#uid=10Y0u0kIDqxMMfxJBljJ7yWwZKQ

  0: {
    /* Palette URL: http://paletton.com/#uid=1000u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#E00000" /* Main Primary color */,
    1: "#4F0000",
    2: "#A20000",
    3: "#FF0000",
    4: "#FF0000",
  },

  20: {
    /* Palette URL: http://paletton.com/#uid=10k0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#E04E00" /* Main Primary color */,
    1: "#4F1C00",
    2: "#A23800",
    3: "#FF5900",
    4: "#FF5900",
  },

  40: {
    /* Palette URL: http://paletton.com/#uid=10D0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#E07800" /* Main Primary color */,
    1: "#4F2B00",
    2: "#A25700",
    3: "#FF8900",
    4: "#FF8900",
  },

  60: {
    /* Palette URL: http://paletton.com/#uid=10X0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#E09500" /* Main Primary color */,
    1: "#4F3500",
    2: "#A26C00",
    3: "#FFAA00",
    4: "#FFAA00",
  },

  80: {
    /* Palette URL: http://paletton.com/#uid=11g0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#E0AE00" /* Main Primary color */,
    1: "#4F3E00",
    2: "#A27D00",
    3: "#FFC600",
    4: "#FFC600",
  },

  100: {
    /* Palette URL: http://paletton.com/#uid=11-0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#E0C500" /* Main Primary color */,
    1: "#4F4600",
    2: "#A28E00",
    3: "#FFE100",
    4: "#FFE100",
  },

  120: {
    /* Palette URL: http://paletton.com/#uid=11T0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#E0E000" /* Main Primary color */,
    1: "#4F4F00",
    2: "#A2A200",
    3: "#FFFF00",
    4: "#FFFF00",
  },

  140: {
    /* Palette URL: http://paletton.com/#uid=12c0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#A6D600" /* Main Primary color */,
    1: "#3B4C00",
    2: "#789A00",
    3: "#C1F900",
    4: "#C5FE00",
  },

  160: {
    /* Palette URL: http://paletton.com/#uid=12w0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#6DCB00" /* Main Primary color */,
    1: "#274800",
    2: "#4F9300",
    3: "#82F300",
    4: "#88FE00",
  },

  180: {
    /* Palette URL: http://paletton.com/#uid=12P0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#00B300" /* Main Primary color */,
    1: "#003F00",
    2: "#008100",
    3: "#00E500",
    4: "#00FD00",
  },

  200: {
    /* Palette URL: http://paletton.com/#uid=1380u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#009467" /* Main Primary color */,
    1: "#003425",
    2: "#006B4A",
    3: "#00D293",
    4: "#00FBAF",
  },

  210: {
    /* Palette URL: http://paletton.com/#uid=13i0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#008686" /* Main Primary color */,
    1: "#003030",
    2: "#006161",
    3: "#00CACA",
    4: "#00FAFA",
  },

  /* Palette URL: http://paletton.com/#uid=13s0u0kYWs4Xg9YXfkhZDKsBAZ- */
  220: {
    0: "#005F8D" /* Main Primary color */,
    1: "#002232",
    2: "#014566",
    3: "#008BCF",
    4: "#0AACFB",
  },

  230: {
    /* Palette URL: http://paletton.com/#uid=13B0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#014592" /* Main Primary color */,
    1: "#001934",
    2: "#013269",
    3: "#0163D1",
    4: "#107FFB",
  },

  240: {
    /* Palette URL: http://paletton.com/#uid=13L0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#012E96" /* Main Primary color */,
    1: "#011135",
    2: "#01226C",
    3: "#0141D3",
    4: "#155BFB",
  },

  260: {
    /* Palette URL: http://paletton.com/#uid=1440u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#0F019C" /* Main Primary color */,
    1: "#060137",
    2: "#0C0270",
    3: "#1401D7",
    4: "#2F1BFC",
  },

  280: {
    /* Palette URL: http://paletton.com/#uid=14o0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#380198" /* Main Primary color */,
    1: "#140136",
    2: "#29016E",
    3: "#4E01D5",
    4: "#6813FB",
  },

  300: {
    /* Palette URL: http://paletton.com/#uid=14H0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#600195" /* Main Primary color */,
    1: "#220035",
    2: "#46016C",
    3: "#8800D3",
    4: "#A60BFB",
  },

  320: {
    /* Palette URL: http://paletton.com/#uid=1500u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#A00082" /* Main Primary color */,
    1: "#39002E",
    2: "#74005E",
    3: "#DA00B0",
    4: "#FC00CC",
  },

  340: {
    /* Palette URL: http://paletton.com/#uid=15k0u0kYWs4Xg9YXfkhZDKsBAZ- */
    0: "#C1004B" /* Main Primary color */,
    1: "#45001B",
    2: "#8C0036",
    3: "#ED005C",
    4: "#FD0062",
  },
};
